import React from 'react';
import { Typography } from '@fiverr-private/typography';
import { useFormContext } from '../FormContext';
import type { FormTextHelper } from '../types';
import { FORM_HELPER_TEXT_ID } from '../constants';
import { getValidationColor } from '../FormControl/helpers';
import { getMessage } from './helpers';

const FormHelperText = ({ error, isError: isErrorProp, isSuccess: isSuccessProp, ...restProps }: FormTextHelper) => {
  const { isError, isSuccess, error: formError } = useFormContext();
  const isErrorInternal = isErrorProp || isError;
  const isSuccessInternal = isSuccessProp || isSuccess;
  const message = getMessage({
    isError: isErrorInternal,
    isSuccess: isSuccessInternal,
    error: error || formError,
    ...restProps,
  });
  const color = getValidationColor({ isError: isErrorInternal, isSuccess: isSuccessInternal });

  return message ? <Typography color={color}>{message}</Typography> : null;
};

FormHelperText.id = FORM_HELPER_TEXT_ID;
FormHelperText.displayName = FORM_HELPER_TEXT_ID;

export default FormHelperText;
